export default "/v10.0.0/356cdeb/bundles/opensearch.xml";